import { GlFormCheckboxGroup } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { glSlotsMixin } from '~/lib/utils/vue3compat/gl_slots_mixin';
export default {
    name: 'MultipleChoiceSelector',
    components: {
        GlFormCheckboxGroup
    },
    mixins: [
        glSlotsMixin
    ],
    model: {
        prop: 'checked',
        event: 'input'
    },
    props: {
        checked: {
            type: Array,
            required: false,
            default: ()=>[]
        }
    },
    emits: [
        'input'
    ]
};
